import './preprocessDyson';
import { useRef } from 'react';
import { useAsset } from '@artica/assets';
import { parallax } from '@immutabl3/alchemy/three';
import ClonerArms from './ClonerArms';
import Flocking from './Flocking';

export default function Contents() {
  const { materials } = useAsset('dyson');

  const emissiveMap = useAsset('dyson_glow');

  materials.flockingmat.emissiveMap = emissiveMap;
  materials.default.emissiveMap = emissiveMap;
  
  const group = useRef();

  return (
    <parallax.group
      ref={ group }
      dispose={ null }

      beaker="chapter2"
    >
      <ClonerArms />
      <Flocking />
    </parallax.group>
  );
};